module.exports = __webpack_public_path__ + "img/btn_save.83cafead.svg";